module.exports = __webpack_public_path__ + "static/img/visa-logo.a86cf6a2.svg";